export const portfolioItems = [
	{
		id: 1,
		client: 'den Travak',
		skills: 'Logo design',
		type: ['Graphic Design'],
		thumb: './assets/denTravak.jpg',
		website: 'https://www.dentravak.be/',
		images: [
			'./assets/dentravak/dentravak1.jpg',
			'./assets/dentravak/dentravak2.jpg',
			'./assets/dentravak/dentravak3.jpg',
		],
		description: `Den Travak serves as a social employment initiative, offering a support system for individuals who are currently unable or not yet ready to engage in conventional or secure employment due to personal or societal circumstances. Their aim was to incorporate a retro aesthetic by utilizing hues of yellow, orange, and brown.`,
	},
	{
		id: 2,
		client: 'Maria Galland Keerbergen',
		skills: 'UI, Wordpress',
		type: ['Development', 'UI'],
		thumb: './assets/mariagalland.jpg',
		website: 'http://mariagallandkeerbergenbe.webhosting.be/',
		images: ['./assets/mariagalland.jpg'],
		description:
			'Keerbergen is home to Maria Galland, a beauty center where I took charge of designing and developing their WordPress website.',
	},
	{
		id: 3,
		client: 'Goddess Clothes',
		skills: 'UI, Graphic design, Photo editing, Webshop',
		type: ['Development', 'UI', 'Graphic Design'],
		thumb: './assets/goddessclothes.jpg',
		website: 'http://www.goddessclothes.be/',
		images: [
			'./assets/goddessclothes.jpg',
			'./assets/goddessclothes2.jpg',
			'./assets/goddessclothes3.jpg',
			'./assets/goddessclothes4.jpg',
			'./assets/goddessclothes5.jpg',
			'./assets/goddessclothes6.png',
		],
		description: `I had the opportunity to work on various aspects for a vibrant and distinctive brand "GoddessClothes" specializing in fair trade clothing inspired by Goddess spirituality, medieval aesthetics, and ethnic influences. My contributions encompassed creating their website, webshop, editing product photos, and designing flyers.`,
	},
	{
		id: 4,
		client: 'Woodson and River',
		skills: 'Logo design, Wordpress website development and design',
		type: ['UI', 'Graphic Design', 'Development'],
		thumb: './assets/woodsonandriver.png',
		website: 'http://www.woodsonandriver.be/',
		images: [
			'./assets/woodsonandriver.png',
			'./assets/woodsonandriver2.png',
			'./assets/woodsonandriver3.png',
		],
		description: `I had the privilege of designing the logo and website for Woodson & River, a company renowned for crafting exquisite epoxy tables.`,
	},
	{
		id: 5,
		client: 'Vendatouch',
		skills: 'Logo design, Wordpress website development and design',
		type: ['UI', 'Graphic Design', 'Development'],
		thumb: './assets/vendatouch.jpg',
		website: 'https://vendatouch.eu/',
		images: [
			'./assets/vendatouch.jpg',
			'./assets/vendatouch2.png',
			'./assets/vendatouch3.png',
		],
		description: `I undertook the task of designing, developing, and creating the logo for VendaTouch, a cutting-edge fashion retail software solution. Additionally, I built their website using the WordPress platform.`,
	},
	{
		id: 6,
		client: 'Acheter pour louer',
		skills: 'Mobile app design, UX design',
		type: ['UI', 'Graphic Design'],
		thumb: './assets/acheterpourlouer/apl.jpg',
		website: 'https://acheterpourlouer.be/',
		images: [
			'./assets/acheterpourlouer/apl.jpg',
			'./assets/acheterpourlouer/apl1.jpg',
			'./assets/acheterpourlouer/apl2.jpg',
			'./assets/acheterpourlouer/apl3.jpg',
			'./assets/acheterpourlouer/apl4.jpg',
			'./assets/acheterpourlouer/apl5.jpg',
		],
		description: `I had the privilege of designing the mobile app and UX for Acheter Pour Louer, a pioneering retail business that empowers clients to acquire tutorials and coaching on real estate investment and property rental for generating passive income. Subscribers can conveniently access these tutorials through the mobile app and engage in discussions with fellow community members to exchange ideas.`,
	},
	{
		id: 7,
		client: 'Hakao',
		skills: 'Logo design',
		type: ['Graphic Design'],
		thumb: './assets/hakao.jpg',
		website: 'https://www.hakao.be/',
		images: ['./assets/hakao.jpg'],
		description: `I had the opportunity to design a logo for a community of doctors called HAKAO.`,
	},
	{
		id: 8,
		client: 'Tetris',
		skills: 'Game development',
		type: ['Development'],
		thumb: './assets/tetris.png',
		website: 'https://tetrissss.netlify.app/',
		git: 'https://gitlab.com/shakkamakka/tetris',
		images: ['./assets/tetris.png'],
		description: `Remake the classic Tetris game for practising purposes and fun!`,
	},
	{
		id: 9,
		client: 'Memory Game',
		skills: 'Game development',
		type: ['Development'],
		thumb: './assets/memorygame.png',
		website: 'https://language-memory-game.herokuapp.com/',
		git: 'https://gitlab.com/shakkamakka/memory',
		images: ['./assets/memorygame.png'],
		description: `I developed a memory game that enables users to enhance their knowledge of fruits in various languages, incorporating a speech feature as well.`,
	},
	{
		id: 10,
		client: 'Personal Kanban board',
		skills: 'App development',
		type: ['Development'],
		thumb: './assets/kanban.png',
		website: 'https://voluble-gumdrop-534720.netlify.app/',
		git: 'https://gitlab.com/shakkamakka/kanban-board',
		images: ['./assets/kanban-board.gif', './assets/kanban.png'],
		description: `By utilizing Localstorage, you can explore the minimal kanban board, where you have the ability to set up and save your own tasks directly in your browser.`,
	},
];
